import { render, staticRenderFns } from "./RankChartsRate.vue?vue&type=template&id=47f6961e&scoped=true"
import script from "./RankChartsRate.vue?vue&type=script&lang=js"
export * from "./RankChartsRate.vue?vue&type=script&lang=js"
import style0 from "./RankChartsRate.vue?vue&type=style&index=0&id=47f6961e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f6961e",
  null
  
)

export default component.exports